import axios from 'axios'
import { Message } from 'element-ui'
import { getToken } from '@/utils/cookie'
import store from '@/store'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 60000,
})

// request拦截器
service.interceptors.request.use(config => {
  if (getToken) {
    // 自定义头部
    config.headers['x-token'] = getToken() 
  }
  return config
}, error => {
  console.log(error) //   for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    const resp = response.data;
    switch (resp.code) {
      case 0:
      case '0000':
        return response.data;
        break;
      case '2401':
      	// 登出
      	store.dispatch('FedLogOut').then(() => {
	        location.reload();
	      });
      	return Promise.reject('error');
      	break;
      case '2000':
      case '2100':
      case '2601':
      case '3000':
        Message({
          message: resp.message,
          type: 'error',
          duration: 3 * 1000
        });
        return Promise.reject('error');
        break;
      case '3001':
        Message({
          message: resp.message,
          type: 'error',
          duration: 3 * 1000
        });
        return Promise.reject('error');
        break;
      default:
        return Promise.reject(resp);
        break;
    }
  },
  error => {
    return Promise.reject(error)
  }
)

// export default service
export default {
  post (url, data) {
    return new Promise((resolve, reject) => {
      service.post(
        url,
        data
      ).then(function (resp) {
        resolve(resp)
      }).catch(function (error) {
        reject(error);
      })
    })
  },
  post (url, data, config) {
    return new Promise((resolve, reject) => {
      service.post(
        url,
        data,
        config
      ).then(function (resp) {
        resolve(resp)
      }).catch(function (error) {
        reject(error);
      })
    })
  },
  get (url, data) {
    return new Promise((resolve, reject) => {
      service.get(
        url,
        data
      ).then(function (resp) {
        resolve(resp)
      }).catch(function (error) {
        reject(error);
      })
    })
  },
  upload (url, data) {
    return new Promise((resolve, reject) => {
      service.post(
        url,
        data,
        {
          headers:{'Content-Type':'multipart/form-data'}
        }
      ).then(function (resp) {
        resolve(resp)
      }).catch(function (error) {
        reject(error);
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/core/axios.js